import { css } from '@emotion/react';
import { cardStyles } from '../../../theme/component-styles';

const listHeight = '40dvh';

export const mprListContainerCss = css`
  height: ${listHeight};
  max-height: ${listHeight};
`;

export const mprListRowCss = css({
  display: 'grid',
  gridTemplateColumns: 'auto minmax(0, 1fr) auto auto',
  columnGap: '1rem',
  alignItems: 'center',
  ...cardStyles,
  padding: '0 0.5rem 0 0',
});
